import { Translate } from "../types"

const translate_EN: Translate =  {
    Language: {
        it: "Italian",
        en: "English",
        de: "German"
    },

    Municipal: {
        bolzano: "Bolzano",
        merano: "Merano",
        brunico: "Brunico",
        bressanone: "Bressanone"
    },

    ButtonText: {
        start: 'START',
        next: 'NEXT',
        confirm: 'CONFIRM',
        customise: 'CUSTOMIZE',
        cancel: 'CANCEL',
        download: 'DOWNLOAD',
        try_again: 'TRY AGAIN',
        read_more: 'READ MORE'
    },

    PuzzleText:{
        station4: {
            bolzano: 'Giardino delle',
            merano: 'Park',
            bressanone: 'Giardini',
            brunico: 'Passeggiata'
        },

        station4_sport: { //Translate to English
            bolzano: {title: '263213715', text: 'Arrampicata, Karate, Calcio, Ciclismo, Golf, Sci, Pallavolo, Nuoto, Tennis'},
            merano: {title: '65157', text: 'Tennis, Calcio, Sci, Ciclismo, Arrampicata'},
            bressanone: {title: '3216', text: 'Karate, Calcio, Pallacanestro, Arrampicata'} ,
            brunico: {title: '55944', text: 'Karate, Calcio, Pallacanestro, Ciclismo, Nuoto'} 
        },

        station5_puzzle2: 'cartoon Desi'
    },  

    Text: {
        select_cat_character_title: 'Choose the cat you identify with the most',
        found: 'FOUND',
        and: 'and',
        drag_here_answer: 'Drag the answer here',
        loading: 'Loading...',
        reset: 'Reset',
        retry: 'Retry',
        unableToLoadImage: "Unable to load image",
        checkConnectionRetry: "Please check your connection and try again",
        imageLoadError: "Error loading image.",

    },

    ErrorText: {
        invalid_qrcode: 'Wrong QRCODE'
    },

    CharacterDogType: {
        dog_geek: 'Brainy',
        dog_music: 'Folky',
        dog_sport: 'Stretchy',
        dog_fashion: 'Sparky'
    }
}

export default translate_EN;